(ns app.toolbox.page
  "Replicant page that embeds the Storrito Toolbox (storrito.com/tools/toolbox/)
   in an iframe that fills the main panel."
  (:require [clojure.string :as str]
            [parts.replicant.query :as query]
            [ui.navbar :as navbar]
            [ui.sidebar :as sidebar]))

(def user-session-query
  {:query/kind :query/user-session})

(def toolbox-embed-url
  (if (str/ends-with? (.-hostname js/location) ".localhost")
    "http://www.storrito.localhost/tools/toolbox/embed/"
    "https://storrito.com/tools/toolbox/embed/"))

(defn render [state]
  (if (query/loading? state user-session-query)
    [:div "loading..."]
    [:div.flex.flex-col.h-full
     (navbar/navbar state)
     [:main.flex-1.overflow-hidden
      [:div.flex.h-full.relative
       (sidebar/sidebar-toggle state)
       (when-not (:ui/hide-side-menu? state)
         (sidebar/sidebar state))
       [:div.w-full.relative
        [:div.container.m-auto.z-10
         [:div.flex.justify-end
          [:button
           {:class ["mt-4" "mr-4" "px-4" "py-2" "text-sm"
                    "font-medium" "rounded-full" "shadow-lg" "text-white"
                    "bg-blue-600" "hover:bg-blue-700" "flex" "items-center"
                    "gap-2"]
            :on {:click [[:ui/modal-open :modals/toolbox-tool-request {}]]}}
           [:i.fas.fa-lightbulb]
           "Request a tool"]]]
        [:iframe.absolute
         {:src toolbox-embed-url
          :class ["flex-1" "w-full" "h-full" "border-0"]
          :allow "clipboard-read; clipboard-write"}]]]]]))

(def page
  {:page-id :pages/toolbox
   :route [["ui" "toolbox"]]
   :on-load (fn [_location]
              [[:ui/hide-sidebar-on-mobile]])
   :render #'render})
